import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/views/layout/index";
export const constantRoutes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  // { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: "/",
    component: Layout,
    redirect: "/index",
    name: "Index",
    meta: {
      title: "工作台",
      icon: "menuindex" // 图标
    },
    children: [
      {
        path: "/index",
        component: () => import("@/views/index/index"),
        name: "Index",
        meta: {
          title: "工作台",
          icon: "menuindex"
        }
      }
    ]
  },
  // {
  //   path: "/template",
  //   component: Layout,
  //   name: "template",
  //   meta: {
  //     title: "模板",
  //     icon: "menuindex" // 图标
  //   },
  //   children: [
  //     {
  //       path: "/elementTable/indexloading",
  //       component: () => import("@/views/template/elementTable/indexloading"),
  //       name: "indexloading",
  //       meta: {
  //         title: "上拉加载表格"
  //       }
  //     },
  //     {
  //       path: "/elementTable/detail",
  //       component: () => import("@/views/template/elementTable/detail"),
  //       name: "elementTableDetail",
  //       meta: {
  //         title: "详情"
  //       }
  //     },
  //     {
  //       path: "/elementTable/indexpage",
  //       component: () => import("@/views/template/elementTable/indexpage"),
  //       name: "indexpage",
  //       meta: {
  //         title: "分页表格"
  //       }
  //     },
  //     {
  //       path: "/elementTable/el-dialog",
  //       component: () => import("@/views/template/elementTable/el-dialog"),
  //       name: "el-dialog",
  //       meta: {
  //         title: "弹窗"
  //       }
  //     }
  //   ]
  // },
  {
    path: "/userManagement",
    component: Layout,
    name: "Administration",
    meta: {
      title: "用户管理",
      icon: "menuindex" // 图标
    },
    children: [
      {
        path: "/userManagement/DoctorUser/index",
        component: () => import("@/views/userManagement/DoctorUser/index"), //
        name: "mediciner",
        meta: {
          title: "用户清单",
          icon: "menuindex"
        }
      }
    ]
  },
  {
    path: "/liveBroadcast",
    component: Layout,
    name: "telecast",
    meta: {
      title: "直播管理",
      icon: "menuindex" // 图标
    },
    children: [
      {
        path: "/liveBroadcast/detailedList/index",
        component: () => import("@/views/liveBroadcast/detailedList/index"), //
        name: "repertoire",
        meta: {
          title: "直播清单",
          icon: "menuindex"
        }
      },
      {
        path: "/liveBroadcast/detailedList/msg",
        component: () => import("@/views/liveBroadcast/detailedList/msg"), //
        name: "LiveBoardcasrMsg",
        hidden: true, // 不在侧边栏显示
        meta: {
          title: "直播信息",
          icon: "menuindex"
        }
      }
    ]
  },
  {
    path: "/resources",
    component: Layout,
    name: "resource",
    meta: {
      title: "资源管理",
      icon: "menuindex" // 图标
    },
    children: [
      {
        path: "/resources/publish/index",
        component: () => import("@/views/resources/publish/index"), // 这里写刚才那个文件的地址
        name: "record",
        meta: {
          title: "发表记录",
          icon: "menuindex"
        }
      },
      {
        path: "/resources/publish/detail",
        component: () => import("@/views/resources/publish/detail"),
        name: "detail",
        meta: {
          title: "草稿箱",
          icon: "menuindex"
        }
      },
      {
        path: "/resources/publish/editFile",
        component: () => import("@/views/resources/publish/editFile"), // 这里写刚才那个文件的地址
        name: "editFile",
        hidden: true, // 不在侧边栏显示
        meta: {
          title: "文章编辑",
          icon: "menuindex"
        }
      },
      {
        path: "/resources/publish/editVideo",
        component: () => import("@/views/resources/publish/editVideo"), // 这里写刚才那个文件的地址
        name: "resourceVideoEdit",
        hidden: true, // 不在侧边栏显示
        meta: {
          title: "视频编辑",
          icon: "menuindex"
        }
      },
      {
        path: "/resources/label/list",
        component: () => import("@/views/resources/label/list"), // 这里写刚才那个文件的地址
        name: "labellist",
        meta: {
          title: "标签管理",
          icon: "menuindex"
        }
      },
      {
        path: "/resources/classCtrl/list",
        component: () => import("@/views/resources/classCtrl/list"), // 这里写刚才那个文件的地址
        name: "classCtrlList",
        meta: {
          title: "专题管理",
          icon: "menuindex"
        }
      },
      {
        path: "/resources/classCtrl/edit",
        component: () => import("@/views/resources/classCtrl/edit"), // 这里写刚才那个文件的地址
        name: "classCtrlEdit",
        hidden: true, // 不在侧边栏显示
        meta: {
          title: "课程编辑",
          icon: "menuindex"
        }
      }
    ]
  },
  {
    path: "/inform",
    component: Layout,
    name: "inform",
    meta: {
      title: "消息管理",
      icon: "menuindex" // 图标
    },
    children: [
      {
        path: "informlist",
        component: () => import("@/views/inform/list/index"),
        name: "informlist",
        meta: {
          title: "消息列表",
          icon: "menuindex"
        }
      },
      {
        path: "addinform",
        component: () => import("@/views/inform/list/add"),
        name: "addinform",
        hidden: true, // 不在侧边栏显示
        meta: {
          title: "消息内容",
          icon: "menuindex"
        }
      }
    ]
  }
];
export const asyncRoutes = [];

// export const asyncRouterMap = [
//   { path: '*', redirect: '/404', hidden: true }
// ]
export const createRouter = () =>
  new Router({
    // mode: 'hash', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
router.selfaddRoutes = function(params) {
  router.matcher = new Router().matcher;
  router.addRoutes(params);
};
export default router;
